import React from "react"
import { Center, Spinner, useTheme } from "@chakra-ui/react"
import { AlertsMapProps } from "./AlertsMapMapbox"
import GMap from "../gmaps/GMap"
import ZoneLayer from "../gmaps/ZoneLayer"
import { ErrorBoundary } from "./ErrorBoundary"
import { useGoogleMapsInitBounds } from "../lib/hooks/useGoogleMapsInitBounds"
import AlertsMapGoogleSupercluster from "./AlertsMapGoogleSupercluster"
import { useFillOpacity } from "../lib/hooks/useDropZoneStyle"

const MAP_ID = "alerts-gmap"

const AlertsMapGoogleMap: React.FC<AlertsMapProps> = ({
  bbox,
  isLoading,
  showServiceZones,
  serviceZones,
  showDropzones,
  dropzones,
  showMaintenanceZones,
  maintenanceZones,
  groupedAlertsEntries,
  refetchAlerts,
  selectedBikeUuid,
  setSelectedBikeUuid,
  onDeselectBike,
  selectedAlertUuid,
  onDeselectAlert,
}) => {
  const initialBounds = useGoogleMapsInitBounds(bbox)
  const theme = useTheme()
  const polygonsFillOpacity = useFillOpacity()

  return (
    <GMap
      mapId={MAP_ID}
      containerStyle={{
        height: "100%",
        width: "100%",
      }}
      initialBounds={initialBounds}
      shareCurrentView
    >
      {/* dropzones */}
      <ZoneLayer
        mapId={MAP_ID}
        zones={dropzones}
        showZones={showDropzones}
        properties={{
          zoneType: "dropzone",
        }}
        layerStyle={{
          fillColor: theme.colors.blue["500"],
          strokeColor: theme.colors.blue["800"],
          strokeWeight: 1,
          fillOpacity: polygonsFillOpacity,
        }}
      />

      {/* cycling_area zones (aka serviceZones) */}
      <ZoneLayer
        mapId={MAP_ID}
        zones={serviceZones}
        showZones={showServiceZones}
        properties={{
          zoneType: "cycling_area",
        }}
        layerStyle={{
          fillColor: theme.colors.purple["500"],
          strokeColor: theme.colors.purple["800"],
          strokeWeight: 1,
          fillOpacity: polygonsFillOpacity,
        }}
      />

      {/* maintenance zones */}
      <ZoneLayer
        mapId={MAP_ID}
        zones={maintenanceZones}
        showZones={showMaintenanceZones}
        properties={{
          zoneType: "maintenance",
        }}
        layerStyle={{
          fillColor: theme.colors.gray["500"],
          strokeColor: theme.colors.gray["800"],
          strokeWeight: 1,
          fillOpacity: polygonsFillOpacity,
        }}
      />

      {/* ALERTS */}
      {isLoading && (
        <Center pos="absolute" w="100%" bottom={8}>
          <Center p={2} bg="white" borderRadius="md" h={50} w={50}>
            <Spinner size="sm" />
          </Center>
        </Center>
      )}

      <ErrorBoundary>
        <AlertsMapGoogleSupercluster
          mapId={MAP_ID}
          groupedAlertsEntries={groupedAlertsEntries}
          refetchAlerts={refetchAlerts}
          selectedBikeUuid={selectedBikeUuid}
          setSelectedBikeUuid={setSelectedBikeUuid}
          onDeselectBike={onDeselectBike}
          selectedAlertUuid={selectedAlertUuid}
          onDeselectAlert={onDeselectAlert}
        />
      </ErrorBoundary>
    </GMap>
  )
}

export default AlertsMapGoogleMap
